var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 17.3333C19.6816 17.3333 22.6663 14.3486 22.6663 10.6667C22.6663 6.98477 19.6816 4 15.9997 4C12.3178 4 9.33301 6.98477 9.33301 10.6667C9.33301 14.3486 12.3178 17.3333 15.9997 17.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 28.0002C26.6663 25.1712 25.5425 22.4581 23.5421 20.4577C21.5418 18.4573 18.8287 17.3335 15.9997 17.3335C13.1707 17.3335 10.4576 18.4573 8.4572 20.4577C6.45681 22.4581 5.33301 25.1712 5.33301 28.0002M26.6663 28.0002C26.6663 25.1712 25.5425 22.4581 23.5421 20.4577C21.5418 18.4573 18.8287 17.3335 15.9997 17.3335C13.1707 17.3335 10.4576 18.4573 8.4572 20.4577C6.45681 22.4581 5.33301 25.1712 5.33301 28.0002",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8303_3222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9997 10.6667) rotate(56.1728) scale(11.9755 21.3671)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1772,
    stopColor: "#151F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607973,
    stopColor: "#113782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85436,
    stopColor: "#919BEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8303_3222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9997 22.6668) rotate(36.7275) scale(13.3086 24.6104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1772,
    stopColor: "#151F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607973,
    stopColor: "#113782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85436,
    stopColor: "#919BEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashProfile);
export default __webpack_public_path__ + "static/media/dash_profile.7351a990cdf21a633371daceb6b4de1d.svg";
export { ForwardRef as ReactComponent };